var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72228 6.11117C9.26204 6.11117 8.88894 6.48426 8.88894 6.9445C8.88894 7.40474 9.26204 7.77783 9.72228 7.77783H13.0556C13.5158 7.77783 13.8889 7.40474 13.8889 6.9445C13.8889 6.48426 13.5158 6.11117 13.0556 6.11117H9.72228Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88894 10.2778C8.88894 9.8176 9.26204 9.4445 9.72228 9.4445H13.0556C13.5158 9.4445 13.8889 9.8176 13.8889 10.2778C13.8889 10.7381 13.5158 11.1112 13.0556 11.1112H9.72228C9.26204 11.1112 8.88894 10.7381 8.88894 10.2778Z",
    fill: "#71869D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00005 2.77783C3.77275 2.77783 2.77783 3.77275 2.77783 5.00005V9.16672C2.77783 9.62696 3.15093 10.0001 3.61117 10.0001H5.83339V16.4096C5.83339 17.2372 6.82241 17.6646 7.42513 17.0973L9.02784 15.5889L10.8178 17.2736C11.1387 17.5756 11.6392 17.5756 11.9601 17.2736L13.7501 15.5889L15.3528 17.0973C15.9555 17.6646 16.9445 17.2373 16.9445 16.4096V5.00005C16.9445 3.77275 15.9496 2.77783 14.7223 2.77783H5.28417L5.28951 2.79651C5.19477 2.78419 5.09815 2.77783 5.00005 2.77783ZM4.4445 5.00005C4.4445 4.69323 4.69323 4.4445 5.00005 4.4445C5.30688 4.4445 5.55561 4.69323 5.55561 5.00005V8.33339H4.4445V5.00005ZM7.50006 4.46668L7.49372 4.4445H14.7223C15.0291 4.4445 15.2778 4.69323 15.2778 5.00005V14.738L14.5116 14.0168C14.0837 13.6142 13.4164 13.6142 12.9885 14.0168L11.3889 15.5223L9.78935 14.0168C9.36152 13.6142 8.69415 13.6142 8.26632 14.0168L7.50006 14.738V4.46668Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBill);
export default __webpack_public_path__ + "static/media/iconBill.eee8abaf2c7528ac9a27c256689c0d8a.svg";
export { ForwardRef as ReactComponent };